module.exports = __webpack_public_path__ + "static/media/unclocked.2fcfb5b8.svg";